import React from "react";
import { useQuery } from "react-query";
import { getDiffForSubcase } from "./gateway";
import { queryClient } from "src/shared/services/QeuryClient/reactQueryClient";
import { AxiosError, AxiosResponse } from "axios";
import { enqueueSnackbar } from "notistack";
import { useTranslation } from "react-i18next";

interface TGetDiffResponse {
  diff: Object;
  alreadyResolved?: boolean;
}

export default function useGetDiff({
  subcase_id,
  enabled,
  setExpanded,
}: {
  subcase_id: number;
  enabled: boolean;
  setExpanded: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const { t } = useTranslation();

  return useQuery({
    queryFn: () => getDiffForSubcase(subcase_id),
    queryKey: ["subcase_diff", subcase_id],
    onSuccess: async (data: AxiosResponse<TGetDiffResponse>) => {
      if (data.data.alreadyResolved) {
        await queryClient.invalidateQueries("manageCaseApplication");
        enqueueSnackbar(t("Αυτή η εργασία έχει ήδη ολοκληρωθεί"), {
          variant: "success",
        });
      }
    },
    onError: (error: AxiosError<string>) => {
      enqueueSnackbar(error.response?.data, {
        variant: "error",
      });
      setExpanded(false);
    },
    enabled: enabled,
  });
}
